/**
 * Keeps the numeric cart badge in the header in step with the cart.
 *
 * Liquid renders the opening number, so this only reacts to changes. Same
 * approach as bb-cart-progress.js: the theme's own cart events cover its
 * cart code, a fetch wrapper catches anything else that writes to /cart/*,
 * and both funnel into one debounced read of /cart.js so the number always
 * comes from Shopify rather than being counted locally and drifting.
 */
(function () {
  var badges = document.querySelectorAll('[data-bb-cart-count]');
  if (!badges.length) return;

  var shown = null;
  var timer = null;

  function render(count) {
    if (count === shown) return;
    shown = count;
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = count;
      if (count > 0) {
        badges[i].removeAttribute('hidden');
      } else {
        badges[i].setAttribute('hidden', '');
      }
      // the theme's own dot keys off this class on the toggle
      var toggle = badges[i].closest('.cart__toggle');
      if (toggle) toggle.classList.toggle('cart__toggle--has-items', count > 0);
    }
  }

  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart) render(cart.item_count); })
        .catch(function () { /* leave the last good number on screen */ });
    }, 120);
  }

  [
    'theme:cart:added',
    'theme:cart:update',
    'theme:cart:refresh',
    'theme:cart:loaded'
  ].forEach(function (name) {
    document.addEventListener(name, refresh);
  });

  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var result = nativeFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        result.then(refresh, function () {});
      }
      return result;
    };
  }

  // Another tab may have changed the cart, and bfcache can restore a stale badge.
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refresh();
  });
})();
